import { combineReducers } from 'redux'

import app from 'reducers/app'
import auth from 'reducers/auth'
import campaignTargets from 'reducers/campaign-targets'
import notifications from 'reducers/notifications'

const createRootReducer = () =>
  combineReducers({
    app,
    auth,
    campaignTargets,
    notifications,
  })

// Inferred shape of the Redux store — type `useSelector`/`connect` selectors with this instead of `any`.
export type RootState = ReturnType<ReturnType<typeof createRootReducer>>

export default createRootReducer
